// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"M2-z"};